import { Button, CloseIcon } from 'fronton-react';
import React from 'react';
import { Breakpoint } from 'types/utils';
import { useTranslation } from 'react-i18next';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';
import { PictureSources } from '../photos-modal.types';
import {
  closeButton,
  contentPicture,
  layout,
  photoViewport,
  thumbsContainer,
} from './modal-layout-touch.styles';
import { ModalThumbs } from './modal-thumbs';
import { pictureThatIsSameAs } from './utils';

export const ModalLayoutTouch: React.FC<{
  breakpoint: Breakpoint;
  photosThumbs: PictureSources[];
  showedPicture: PictureSources | null;
  onClose: () => void;
  setShowedPicture?: (pic: PictureSources | null) => void;
  hasMorePhotos?: boolean;
  isCheckedGallery?: boolean;
  onRequestMorePhotos?: () => void;
}> = ({
  breakpoint,
  photosThumbs,
  showedPicture,
  onClose,
  setShowedPicture,
  hasMorePhotos = false,
  isCheckedGallery = false,
  onRequestMorePhotos = () => null,
}) => {
  const { t } = useTranslation();
  const { showedPicIdx, showThumbs } = React.useMemo(() => {
    const idx = photosThumbs.findIndex(pictureThatIsSameAs(showedPicture));
    return {
      showThumbs: idx >= 0,
      showedPicIdx: idx,
    };
  }, [showedPicture, photosThumbs]);

  return (
    <div className={layout}>
      {showThumbs && (
        <div className={thumbsContainer}>
          <ModalThumbs
            breakpoint={breakpoint}
            showedPicIdx={showedPicIdx}
            photosThumbs={photosThumbs}
            setShowedPicture={setShowedPicture}
            hasMorePhotos={hasMorePhotos}
            isCheckedGallery={isCheckedGallery}
            onRequestMorePhotos={onRequestMorePhotos}
          />
        </div>
      )}

      <section className={photoViewport} aria-label={t('ui.image.alt')}>
        <ImagePlaceholder
          className={contentPicture}
          src={showedPicture?.urlOriginal || ''}
          loading="lazy"
          alt=""
          fallbackAlt={t('ui.image.alt')}
          fallbackWidth={800}
          fallbackHeight={800}
        />
      </section>

      <Button
        data-qa="modal-close"
        className={closeButton}
        kind="regular"
        variant="secondary"
        size="l"
        aria-label={t('ui.buttons.close')}
        onClick={onClose}
        rounded
        iconOnly
      >
        <CloseIcon />
      </Button>
    </div>
  );
};
